
import { defineComponent, provide } from 'vue'

export default defineComponent({
  setup() {
    provide('typeIconsFolder', require.context('@/assets/types-icons', false));
  },
})
